<div class="a-spinner"
     vTp="spinner"
     [ngClass]="{'a-spinner-visible' : showSpinner || activeSpinner}">
  <div class="a-spinner-content" vTp="content">
    <ng-content></ng-content>
  </div>
  <div class="a-spinner-animation spinner" vTp="loadingicon"></div>
</div>


